import { Box } from '@amzn/awsui-components-core';
import React from 'react';

interface Props {
  label: string;
  value: string;
  visible?: boolean;
}

const MetadataDisplay: React.FC<Props> = ({ label, value, visible = true }) => {
  if (!visible) {
    return null;
  }

  return (
    <div>
      <span>
        <Box variant="strong">{label}:</Box> {value}
      </span>
    </div>
  );
};

export default MetadataDisplay;
